// extracted by mini-css-extract-plugin
export var card = "_75-0";
export var expandedCard = "_75-2";
export var paginated = "_75-1";